import React from "react";
import LogoutIcon from "@mui/icons-material/Logout";

const UserDetails = ({ userInfo, onClose, handleLogout }) => {
  //   console.log(userInfo.userName);
  return (
    <div className="fixed inset-0 flex items-start mt-2 mr-2 justify-end z-50">
      <div className="bg-white p-4 rounded-lg shadow-lg">
        <img
          src={userInfo.image}
          alt="User"
          className="w-16 h-16 rounded-full mx-auto mb-4"
        />
        <h3 className="text-xl font-semibold mb-2 text-gray-500 text-center">
          {userInfo.userName}
        </h3>
        <p className="text-gray-500">{userInfo.email}</p>
        <div className="flex">
          <button
            onClick={onClose}
            className="mt-4 px-4 py-2 bg-blue-900 hover:bg-blue-950 text-white rounded-md focus:outline-none"
          >
            Close
          </button>
          <div
            onClick={handleLogout}
            className="mt-4 ml-16 px-4 py-2 bg-blue-900 hover:bg-blue-950 text-white rounded-md focus:outline-none"
          >
            <LogoutIcon />
            <p className="inline-flex text-xs font-semibold text-whiteText cursor-pointer">
              Log out
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
